export default __webpack_public_path__ + "static/media/IWIMHub.5acda4b0.jpg";